import { Fragment, useState } from "react";
import { Autocomplete, InputLabel, TextField, Typography, createFilterOptions } from "@mui/material";
import { Debounce } from "utils";

function SelectField(props) {

  const { label, size, disabled, onSearch, addNew, multiple, selected, onSelect, register, error, options } = props;

  const filter = createFilterOptions();
  const [inputValue, setInputValue] = useState("");

  // *For Handle Filter Option
  const handleFilterOptions = (options, params) => {
    const filtered = filter(options, params);

    const { inputValue } = params;
    const isExisting = options.some((option) => inputValue === option.name);
    if (inputValue !== "" && !isExisting && addNew) {
      filtered.push({
        inputValue,
        name: `Add "${inputValue}"`,
      });
    }

    return filtered;
  };

  // *For Handle Option Label
  const handleOptionLabel = (option) => {
    if (typeof option === "string") {
      return option;
    }
    if (option.inputValue && addNew) {
      return option.inputValue;
    }
    return option.name;
  };

  // *For Handle Change
  const handleChange = (newValue) => {
    if (typeof newValue === "string") {
      onSelect(newValue);
      setInputValue(""); // reset input after select
      return;
    }
    if (newValue && newValue.inputValue && addNew) {
      addNew(newValue?.inputValue);
      setInputValue(""); // reset input after add new
      return;
    }
    onSelect(newValue);
    setInputValue(""); // reset input after normal select
  };

  // *For Handle Search
  const handleSearch = (value) => {
    setInputValue(value); // keep input controlled
    if (onSearch) {
      Debounce(() => onSearch(value));
    }
  };

  return (
    <Fragment>
      <InputLabel sx={{ color: "#323B4B" }} error={error && selected === "" && true}>
        {label}
      </InputLabel>
      <Autocomplete
        disabled={disabled}
        size={size}
        multiple={multiple}
        isOptionEqualToValue={(option, value) => option?.name === value?.name}
        value={selected}
        inputValue={inputValue} // controlled input
        options={options}
        filterOptions={(options, params) => handleFilterOptions(options, params)}
        getOptionLabel={(option) => handleOptionLabel(option)}
        onChange={(event, newValue) => handleChange(newValue)}
        onInputChange={(event, newInputValue) => handleSearch(newInputValue)}
        sx={{ mt: 1, mb: !error && 2 }}
        renderOption={(props, option) => <li {...props}>{option.name}</li>}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={label}
            error={error}
            {...register}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <Fragment>
                  {params.InputProps.endAdornment}
                </Fragment>
              ),
            }}
          />
        )}
      />
      {error && (
        <Typography variant="caption" color="error" sx={{ textAlign: "left" }}>
          {error}
        </Typography>
      )}
    </Fragment>
  );
}

export default SelectField;
